import { __local_cdn__, entryPointId, PAGE_TYPES } from 'settings/app/constants'

// TODO rename props in plugin then we can remove this and map over entryPointId
export const MAPPED_REDIRECT_KEYS = {
  cross: 'crossSearchURL',
  doctors: 'doctorsSearchURL',
  hospitals: 'hospitalsSearchURL',
  oncallservices: 'oncallServicesSearchURL',
  midwives: 'midwivesSearchURL',
  ambulances: 'ambulancesSearchURL',
  caresearch: 'careSearchSearchURL',
  caresupport: 'careSupportsSearchURL',
  careservices: 'careServicesSearchURL',
  carehomes: 'careHomesSearchURL',
  dayandnightcare: 'dayAndNightCaresSearchURL',
}

/**
 * entrypoint which belongs to health navigator
 * @type {string[]}
 */
export const HEALTH_ENTRYPOINT = [
  'cross',
  'doctors',
  'hospitals',
  'midwives',
  'ambulances',
  'oncallservices',
]

/**
 * contains all injected typo props (please extend if something is missing)
 * @type {{headerProps: string[], application: string[], seoPage: string[], redirects: {hospitals: string[], dayandnightcare: string[], caresearch: string[], carehomes: string[], doctors: string[], cross: string[], caresupport: string[], oncallservices: string[], midwives: string[], careservices: string[], ambulances: string[]}}}
 */
const requiredEnvironmentVars = {
  // redirectURLs for routing from startPage to resultPages (only required in productive mode)
  redirects: {
    cross: [
      'crossSearchURL',
      'doctorsSearchURL',
      'hospitalsSearchURL',
      'midwivesSearchURL',
      'ambulancesSearchURL',
      'oncallServicesSearchURL',
    ],
    hospitals: ['doctorsSearchURL', 'hospitalsSearchURL'],
    doctors: ['doctorsSearchURL'],
    midwives: ['midwivesSearchURL'],
    ambulances: ['ambulancesSearchURL'],
    oncallservices: ['oncallServicesSearchURL'],
    // care navi
    careservices: ['careServicesSearchURL'],
    carehomes: ['careHomesSearchURL'],
    caresupport: ['careSupportsSearchURL'],
    dayandnightcare: ['dayAndNightCaresSearchURL'],
    caresearch: [
      'careSearchSearchURL',
      'careServicesSearchURL',
      'careHomesSearchURL',
      'dayAndNightCaresSearchURL',
      'caresupportsSearchURL',
    ],
  },
  // searchBar props (required for all cases)
  headerProps: ['headerImage', 'headerTitle', 'textTitle', 'text'],
  // primary props (required for all cases)
  application: ['entryPoint', 'pageType', 'assetPath'],
  // seo props (have to modified when we have for different types (cur: doctors)
  seoPage: [
    'searchQuery',
    'searchLocation',
    'searchRadius',
    'searchKey',
    'searchType',
  ],
}

/**
 * basic prop check
 * @param envType
 * @param entryPoint
 * @returns {string|boolean}
 */
export const checkEnvironmentVarsByProp = (envType, entryPoint = false) => {
  try {
    if (!requiredEnvironmentVars.hasOwnProperty(envType)) {
      alert(`could not access property => ${ envType } @ requiredEnvironmentVars`)
    }

    const envErrors = []
    const envVarsArray = !entryPoint
      ? requiredEnvironmentVars[envType]
      : requiredEnvironmentVars[envType][entryPoint]

    // iterate over props have to wait for accessing values
    envVarsArray.forEach((envVar) => {
      const localStorageValue = localStorage.getItem(envVar)

      if (localStorageValue === null) {
        envErrors.push(`Fehler: Property ${ envVar } fehlt.`)
      } else if (localStorage.getItem(envVar) === '') {
        envErrors.push(`Fehler: Property ${ envVar } ist ein Leerstring.`)
      }

      if (
        envVar === 'assetPath' &&
        !__local_cdn__ &&
        envVar !== 'https://navigatoren-cdn.aok.de/'
      ) {
        envErrors.push(
          `Fehler: assetPath ${ envVar }, der Wert: ${ localStorageValue } ist nicht zulässig.`
        )
      }

      if (
        envVar === 'pageType' &&
        !Object.keys(PAGE_TYPES).filter(
          (i) => PAGE_TYPES[i] === localStorageValue
        ).length
      ) {
        envErrors.push(
          `Fehler: PAGE_TYPES ${ envVar }, der Wert: ${ localStorageValue } ist nicht zulässig. Zulässige Werte, siehe: PAGE_TYPES`
        )
      }

      if (
        envVar === 'entryPoint' &&
        !Object.keys(entryPointId).filter(
          (i) => entryPointId[i] === localStorageValue
        ).length
      ) {
        envErrors.push(
          `Fehler: EntryPoint ${ envVar }, der Wert: ${ localStorageValue } ist nicht zulässig. Zulässige Werte, siehe: entryPointId`
        )
      }

      // currently we use client only for doctors at seo mode
      if (envType === PAGE_TYPES.SEO_PAGE) {
        const locationRadius = localStorage.getItem('searchRadius')
        const expectRadius = ['0', '5000', '10000', '20000', '50000', '100000']

        if (!expectRadius.includes(locationRadius)) {
          envErrors.push(
            `Radius zulässige Werte sind 0 = Bundesweit, 5000, 10000, 20000, 50000, 100000, bitte korrigieren.`
          )
        }
      }
    })

    if (envErrors.length !== 0) {
      console.group(
        `@Folgende Fehler (type:${ envType }) in der Plugin Konfiguration wurden gefunden.`
      )
      envErrors.forEach((err) => console.log(err))
      console.groupEnd()
    } else {
      console.log(
        `** Keine Fehler für ${ envType } Props in den Plugin Parametern gefunden. **`
      )
    }
  } catch (e) {
    console.log('Fehler fn.checkEnvironmentVarsByProp MSG => ', e)
  }
}
